"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const Table_styles_1 = require("./Table.styles");
const Table = props => {
  const {
    columns,
    data,
    onRowClick
  } = props;
  return (0, jsx_runtime_1.jsxs)(Table_styles_1.TableEl.StyledTable, {
    children: [(0, jsx_runtime_1.jsx)(Table_styles_1.TableEl.THead, {
      children: (0, jsx_runtime_1.jsx)(Table_styles_1.TableEl.Tr, {
        children: columns?.map((column, i) => (0, jsx_runtime_1.jsx)(Table_styles_1.TableEl.Th, {
          textAlign: column.align,
          onClick: () => {
            if (column.onHeaderClick) {
              column.onHeaderClick(column);
            }
          },
          className: column.className,
          children: (0, jsx_runtime_1.jsxs)(Table_styles_1.CellContent, {
            children: [column.title, column.onHeaderClick && (0, jsx_runtime_1.jsx)(Table_styles_1.SortButton, {
              sortDirection: column.sortOrder
            })]
          })
        }, i))
      })
    }), (0, jsx_runtime_1.jsx)(Table_styles_1.TableEl.TBody, {
      children: data?.map((item, index) => {
        return (0, jsx_runtime_1.jsx)(Table_styles_1.TableEl.Tr, {
          hoverable: !!onRowClick,
          onClick: () => {
            if (onRowClick) {
              onRowClick(item);
            }
          },
          children: columns?.map((column, i) => (0, jsx_runtime_1.jsx)(Table_styles_1.TableEl.Td, {
            textAlign: column.align,
            className: column.className,
            children: column.render ? column.render(item[column.dataIndex], item, index) : item[column.dataIndex]
          }, i))
        }, index);
      })
    })]
  });
};
exports.default = Table;